import { UseQueryOptions } from '@tanstack/react-query';

import APIError from 'types/api_error';
import { NotificationCategory } from 'types/notification_rule';

import { useAPI } from 'hooks/api/useAPI';
import { useAuthenticatedQuery } from 'hooks/api/useAuthenticatedQuery';

type UseNotificationCategoriesOptions = UseQueryOptions<
  NotificationCategory[],
  APIError
>;

export function useNotificationCategories(
  options: UseNotificationCategoriesOptions = {}
) {
  const { applicationID, client } = useAPI();

  return useAuthenticatedQuery(
    ['notification-categories', applicationID],
    async () => {
      const { data } = await client.get<NotificationCategory[]>(
        `/apps/${applicationID}/notification_categories`
      );
      return data;
    },
    { staleTime: Infinity, ...options }
  );
}
